import React, { Suspense, useState } from 'react';
import LazyLoad, { lazyload } from 'react-lazyload';
import { Lottie } from '@crello/react-lottie';

import Head from 'next/head';

import st from './index.module.scss';

import Pricing from '../../../components/video-production/Pricing';
import BradCrumbs from '../../../components/Base/BradCrumbs';
import Engagement from '../../../components/Engagement';
import Faq from '../../../components/Faq';
import typesLottie from '../../../public/images/types.json';
import Why from '../../../components/Why';
import ViewMore from '../../../components/ViewMore';
import BenefitsCorporate from '../../../components/video-production/explainer-videos/BenefitsCorporate';
import ProcessSliderCorporate from '../../../components/sliders/ProcessSliderCorporate';
import SolveProblemsCorporate from '../../../components/video-production/explainer-videos/SolveProblemsCorporate';

lazyload({
  width: '100%',
});

const ExplainerVideosCorporate = props => {
  const [showPricingModalF, setShowPricingModalF] = useState(false);
  const [videoLength, setVideoLength] = useState([]);
  const [script, setScript] = useState([]);

  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing';
    } else {
      setShowPricingModalF(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      window.location.hash = 'open';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalF(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    history.replaceState(null, null, ' ');
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <>
      <Head>
        <title>Video Production - Corporate Explainer Video | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/video-production/corporate-explainer-video" />
        <meta
          name="description"
          content="Unlock your brand's potential with a captivating corporate explainer video. Engage, educate, and convert your audience effectively. Get started now."
        />
        <meta property="og:url" content="https://weprodigi.com/video-production/corporate-explainer-video" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Video Production - Corporate Explainer Video | Prodigi" />
        <meta
          property="og:description"
          content="Unlock your brand's potential with a captivating corporate explainer video. Engage, educate, and convert your audience effectively. Get started now."
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/explainer-videos/corporate-explainer/og.jpg" />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
              "@context": "http://schema.org",
              "@type": "WebPage",
              "name": "Corporate Explainer Video Production - Custom Animation -  Prodigi",
              "description": "Unlock your brand's potential with a captivating Corporate Explainer Video. Engage, educate, and convert your audience effectively. Get started now!",
              "url": "https://weprodigi.com/video-production/corporate-explainer-video",
              "breadcrumb": {
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://weprodigi.com"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Full Service Video Production",
                    "item": "https://weprodigi.com/video-production"
                  },
                  {
                    "@type": "ListItem",
                    "position": 3,
                    "name": "Corporate Expaliner Video Production",
                    "item": "https://weprodigi.com/video-production/corporate-explainer-video"
                  }
                ]
              },
              "mainEntity": {
                "@type": "Product",
                "name": "Corporate Explainer Video Production",
                "description": "Unlock your brand's potential with a captivating Corporate Explainer Video. Engage, educate, and convert your audience effectively. Get started now!",
                "brand": {
                  "@type": "Brand",
                  "name": "Weprodigi"
                },
                "offers": {
                  "@type": "Offer",
                  "price": "1300",
                  "priceCurrency": "USD",
                  "seller": {
                    "@type": "Organization",
                    "name": "Weprodigi"
                  }
                },
                "image": "https://weprodigi.com/images/logovertical.svg",
                "review": [
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "5",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Liam Wood"
                    },
                    "datePublished": "2024-01-16",
                    "reviewBody": "Prodigi agency doesn't just create corporate explainer videos; they craft immersive experiences that transport viewers into the heart of your brand. Their attention to storytelling and visual aesthetics is second to none."
                  },
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "5",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Robert Harris"
                    },
                    "datePublished": "2024-03-01",
                    "reviewBody": "Prodigi agency's explainer video service is a game-changer for businesses. They take the time to understand your vision and deliver a polished video that leaves a lasting impression."
                  },
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "4.9",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Jacob Clarke"
                    },
                    "datePublished": "2024-02-25",
                    "reviewBody": "Prodigi agency's corporate explainer videos are a must-have for any company looking to communicate their message effectively. Their creativity and expertise set them apart from the rest."
                  }
                ],
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "ratingValue": "4.9",
                  "reviewCount": "3"
                }
              }
            }                                                
            `,
          }}
        />
      </Head>

      {/*    Header video */}
      <div className={`relative w-full  h-intro  overflow-hidden  `}>
        <video
          width="100%"
          height="100%"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          id="header-11"
          className={'absolute h-intro md:h-full ' + st['header-mp4']}
        >
          <source src="https://weprodigi.com/uploads/images/explainer-videos/corporate-explainer/corporate-explainer.mp4" type="video/mp4" />
        </video>
        <div className={st['overlay']}></div>
        <div className="container h-full">
          <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
            <h1 className="max-w-300 md:max-w-600 uppercase md:normal-case text-white text-30 md:text-72 font-black md:font-bold leading-tight">
              Corporate Explainer Video Production
            </h1>
            <a
              onClick={showPricingModal}
              className="relative flex items-center justify-center min-w-250 z-10 border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-8 bg-green-badge hover:bg-green-hover hover:text-white transition-all   transition-400 cursor-pointer"
            >
              Get Pricing
              <img src="https://weprodigi.com/uploads/images/explainer-videos/buttonIcon.svg" className={'ml-10'} alt="pricing icon" />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container">
          <BradCrumbs
            items={[
              {
                url: '/video-production',
                name: 'Video Production',
              },
              {
                url: '/video-production/explainer-videos',
                name: 'Explainer Video Production',
              },
              {
                url: '/video-production/corporate-explainer-video',
                name: 'Corporate Explainer Video',
              },
            ]}
          />
          <div className="relative pt-20 md:pt-0 pb-48">
            <div className="flex flex-wrap md:flex-nowrap justify-between">
              <LazyLoad className="mr-auto mt-24 md:mt-0 max-w-270 w-full md:w-auto" height={200} once>
                <Lottie
                  config={{
                    animationData: typesLottie,
                    loop: true,
                    autoPlay: true,
                  }}
                  playingState="playing"
                />
              </LazyLoad>
              <div className="flex flex-col ml-12 items-center justify-center max-w-756">
                <Engagement title="Video">
                  A corporate explainer video is an unforgettable introduction to your company. This visual icebreaker will engage and educate your
                  customers. Read more to learn how it works!
                </Engagement>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LazyLoad height={200} once>
        <div className={'bg-gray-white py-24'}>
          <div className="container">
            <h2 className={'w-full lg:w-half-auto font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              What Is a Corporate Explainer Video?
            </h2>

            <div className={'block md:flex justify-between flex-row md:flex-row-reverse'}>
              <div className=" pl-0 md:pl-20 pb-10 w-full md:w-half-auto block  mt-23 mb-10">
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/FDl_Bbzxu1g?controls=0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>AtkinsRealis | 2D Corporate Explainer Video</p>
              </div>

              <p className={'mt-20 w-half-auto hidden md:block'}>
                High engagement is dependent on an impactful brand introduction. Using corporate explainer videos, you can identify your company,
                demonstrate your values, and explain what you do. This video format increases brand visibility and helps you maintain a stable market
                position.
              </p>
              <div className={'mt-20 block md:hidden'}>
                <ViewMore ln={40}>
                  High engagement is dependent on an impactful brand introduction. Using corporate explainer videos, you can identify your company,
                  demonstrate your values, and explain what you do. This video format increases brand visibility and helps you maintain a stable
                  market position.
                </ViewMore>
              </div>
            </div>
            <br className={'clear-both hidden'} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Where to Use Corporate Explainer Video?
            </h2>
            <p className={'mt-20'}>
              Find out all the unique and standout functionalities of corporate explainer video production services. Learn how videos can enhance your
              brand.
            </p>

            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between items-start mt-0 md:mt-24">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/rkmqIjMyvKU?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>SNC-Lavalin | 2D Explainer Video</p>
              </div>

              <div className={'w-full md:w-half-auto mt-24 md:mt-0'}>
                <h3 className="text-purple font-bold text-24   leading-none">Marketing and Advertising</h3>
                <div className={'mt-16 hidden md:block'}>
                  Visible impact is one of the main tools for reserving your spot in the market. Business overview videos or corporate animation
                  visualise your brand awareness, promote your products, simplify the meaning of your offers, and gain high engagement. Let your
                  customers know about your company and the solutions it brings.
                </div>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Visible impact is one of the main tools for reserving your spot in the market. Business overview videos or corporate animation
                    visualise your brand awareness, promote your products, simplify the meaning of your offers, and gain high engagement. Let your
                    customers know about your company and the solutions it brings.
                  </ViewMore>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap md:flex-nowrap justify-between mt-0 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <h3 className="text-purple font-bold text-24 leading-none">Software and Technology</h3>
                <p className={'mt-16'}></p>

                <p className={'mt-16 hidden md:block'}>
                  It's a challenging job to keep your eye-catching spot in this fast-growing industry. Corporate explainer videos let customers learn
                  about your company's missions, values, and offers directly. Explain concepts by simplifying them and building strong customer
                  support. Create digital communication between you and your customers.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    It's a challenging job to keep your eye-catching spot in this fast-growing industry. Corporate explainer videos let customers
                    learn about your company's missions, values, and offers directly. Explain concepts by simplifying them and building strong
                    customer support. Create digital communication between you and your customers.
                  </ViewMore>
                </div>
              </div>
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/1EXzVPREt0o?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>IATA | 2D Corporate Explainer Video</p>
              </div>
            </div>
            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between mt-24 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/d1NdvqffXhI?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>
                  De Courten Solutions | 2D Corporate Explainer Video
                </p>
              </div>

              <div className={'w-full md:w-half-auto '}>
                <h3 className="text-purple font-bold text-24 leading-none">Education and Training</h3>
                <p className={'mt-16 hidden md:block'}>
                  Company introduction clips are a new way to engage new students in your classes. Visualise your course material diversification for
                  better onboarding. Highlight your educational products and let your potential customers feel the atmosphere of your company. Show
                  your education or training creative methods summarised in one engaging video.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={'40'}>
                    Company introduction clips are a new way to engage new students in your classes. Visualise your course material diversification
                    for better onboarding. Highlight your educational products and let your potential customers feel the atmosphere of your company.
                    Show your education or training creative methods summarised in one engaging video.
                  </ViewMore>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-gray-light py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Benefits of Corporate Explainer Videos
            </h2>
            <p className={'mt-20'}>
              Corporate identity videos serve as a prism to spread the shine of your company. Discover the main benefits of this format below.
            </p>
            <Suspense fallback={`Loading...`}>
              <BenefitsCorporate />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="text-purple text-24 md:text-36 text-left mb-23 font-black uppercase leading-none">
              Our Corporate Explainer Video Production Process
            </h2>
            <ProcessSliderCorporate />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={0} once>
        <div className={'h-500 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
          <div id="stars" />
          <div id="stars2" />
          <div id="stars3" />
          <div className="container flex flex-wrap md:flex-nowrap justify-between items-end md:items-center h-full ">
            <div
              className={
                'mt-24 md:mt-0 text-left md:text-center font-bold uppercase  text-white leading-28 md:leading-44   text-20 md:text-26 lg:text-36'
              }
            >
              CALCULATE YOUR CORPORATE EXPLAINER VIDEO PRICE
              <br />
              <span className={'pt-20 font-normal normal-case text-18 md:text-24 leading-20 md:leading-29 '}>
                Answer five questions and get to know the price!
              </span>
              <div className={'flex justify-end md:justify-center mt-0 leading-0'}>
                <button
                  onClick={showPricingModal}
                  className="uppercase h-40 text-18 leading-24  hover:bg-green-hover md:flex justify-center items-center   w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                >
                  Start Now
                </button>
              </div>
            </div>
            <img src="https://weprodigi.com/uploads/images/explainer-videos/Inga.webp" alt="eva" className={st['inga']} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              How Corporate Explainer Video Can Help Your Business?
            </h2>
            <p className={'mt-20'}>
              Explainer video is one of the essential parts of modern marketing campaigns. Here are the main benefits of brand narrative videos that
              can be helpful for your business.
            </p>
            <Suspense fallback={`Loading...`}>
              <SolveProblemsCorporate />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-gray-light">
          <div className="container py-23">
            <h2 className="uppercase text-30 md:text-36 mb-23 font-black text-purple leading-none">
              Why Choose Us for Your Corporate Explainer Video Production?
            </h2>
            <Why
              content={[
                {
                  title: 'We value your time',
                  answer:
                    "We know how important our clients' time is. Outsourcing full-service video production helps save your expensive time. More importantly, we quickly understand your business needs and implement our proven time-saving solutions at all stages of production, from communication to payment methods.",
                },
                {
                  title: 'We include digital marketing specialists in the production process.',
                  answer:
                    "According to Google, 6 out of 10 people prefer watching videos online rather than TV. To create an effective video, you need to consider which platform the video will be used on and master all its features, be it your website, YouTube, Facebook, or Amazon. That's why we include our digital marketing specialists in the production process, who study your business requirements in detail and combine them with the requirements of each online platform to get effective material.",
                },
                {
                  title: "We don't require prepayment.",
                  answer:
                    "We believe the client should pay for the work rather than with deposits. We chose a milestone payment option as we believe it's a more trustworthy approach to our work.",
                },
                {
                  title: "We don't have a single unhappy client.",
                  answer:
                    'We never charge for a product that you have not approved. If you are unsatisfied with the results, 100% money-back is guaranteed.',
                },
              ]}
            />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none">FAQ</h2>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'What types of businesses can benefit from corporate explainer videos?',
                    answer: 'Using corporate explainer videos can be beneficial for all types of businesses, such as marketing, education, IT, etc.',
                  },
                  {
                    title: 'What elements should be included in a corporate explainer video?',
                    answer:
                      'The main elements of a well-made corporate video are a strong script, engaging visuals, professional voiceover, and sound effects to make a stunning impact.',
                  },
                ]}
              />
              <Faq
                content={[
                  {
                    title: 'How can I promote my corporate explainer video?',
                    answer:
                      'A corporate explainer video can be promoted mainly with website placement, email marketing, and any social media platform.',
                  },
                  {
                    title: 'How often should I update or create new corporate explainer videos?',
                    answer: 'The need for a new corporate explainer video depends on your industry and brand changes.',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>

      <Pricing videoLength={videoLength} script={script} country={props.country} show={showPricingModalF} hide={hidePricingModal} step={1} />
    </>
  );
};

export default ExplainerVideosCorporate;
